import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { Flex, Box } from 'reflexbox'
import TimelineFontIcon from './TimelineFontIcon'

import { getHourMinuteNumber } from 'helpers/DateUtil'

import styles from './styles.scss'

const TimelineState = (props) => {
  let { className, date, right, state, action } = props
  let timelineStateClasses = `${styles.timelineState} ${className}`

  let order = [1,2,3]
  if (right)
    order.reverse()

  return (
    <Flex align='flex-start' class={timelineStateClasses}>
      <Box order={order[0]}>
        <span styleName='content'>
          { state }
        </span>
      </Box>
      <Box order={order[1]} styleName='middle'/>
      <Flex order={order[2]} column align='center'>
        <TimelineFontIcon action={action}/>
        <span styleName='timestamp'>
          { getHourMinuteNumber(date) }
        </span>
      </Flex>
    </Flex>
  )
}

TimelineState.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  state: PropTypes.string.isRequired,
  action: PropTypes.string,
  right: PropTypes.bool
}

export default CSSModules(TimelineState, styles)
